import React from 'react';

export class DisclaimerComponent extends React.Component { 
	render() {
	    return (
<div style={{ fontFamily: 'Roboto, Helvetica, Arial, sans-serif,', color:'white', fontSize:'small', backgroundColor:'orange', marginTop:'10px', padding:'5px'}}>
The data provided herein is estimated and is to be used as a guide only. 
Final month-end payment amounts will be posted no later than 15 days after the end of the month.
      </div>
	    )
	}
}